import { createContext, useContext, type AnchorHTMLAttributes, type ReactNode } from 'react';
import { Link } from 'react-router';
import type { PublicSiteInfo } from '@barbeiropro/contracts';

export interface SiteCtx {
  slug: string;
  site: PublicSiteInfo;
  /** pré-visualização no editor: links e envios ficam inertes */
  preview: boolean;
  pageSlug: string;
}

const Ctx = createContext<SiteCtx | null>(null);
export const SiteProvider = ({ value, children }: { value: SiteCtx; children: ReactNode }) => <Ctx.Provider value={value}>{children}</Ctx.Provider>;
export function useSite() {
  const v = useContext(Ctx);
  if (!v) throw new Error('SiteProvider ausente');
  return v;
}

export const pagePath = (slug: string, pageSlug: string) => (pageSlug ? `/b/${slug}/${pageSlug}` : `/b/${slug}`);

/** Link do site: `#agendar` vira a rota de agendamento; externos abrem em nova aba. */
export function SiteLink({ href, children, ...rest }: { href: string; children: ReactNode } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>) {
  const { slug, preview } = useSite();
  const target = href === '#agendar' ? `/b/${slug}/agendar` : href;
  const inert = preview ? { onClick: (e: { preventDefault: () => void }) => e.preventDefault() } : {};
  if (target.startsWith('/')) {
    return (
      <Link to={target} {...rest} {...inert}>
        {children}
      </Link>
    );
  }
  const external = /^https?:/i.test(target);
  return (
    <a href={target} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} {...rest} {...inert}>
      {children}
    </a>
  );
}
